export const en = {
  login: 'Login',
  mail_address: 'Mail Address',
  password: 'Password'
}
